import { ButtonsDropdownOption } from "@visiblethread/react-components";
import {
  ASSIGNABLE_LICENSE_TYPES,
  licenseTypeLabel,
} from "constants/licenseTypes";
import React from "react";

export const LICENSE_TYPE_OPTIONS = ASSIGNABLE_LICENSE_TYPES.map((value) => ({
  content: <span>{licenseTypeLabel(value)}</span>,
  filter: value,
}));

export const getOptionButton = ({ option, setLicenseType }) => (
  <ButtonsDropdownOption
    text={option.content}
    content={option.content}
    onClick={() => {
      setLicenseType(option.filter);
    }}
  />
);
